/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaDistributionBucket from './AqaDistributionBucket';

/**
 * The AqaDistribution model module.
 * @module model/AqaDistribution
 * @version v0
 */
export default class AqaDistribution {
  /**
   * Constructs a new <code>AqaDistribution</code>.
   * @alias module:model/AqaDistribution
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaDistribution</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaDistribution} obj Optional instance to populate.
   * @return {module:model/AqaDistribution} The populated <code>AqaDistribution</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaDistribution();
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
      if (data.hasOwnProperty('axis'))
        obj.axis = ApiClient.convertToType(data['axis'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('buckets'))
        obj.buckets = ApiClient.convertToType(data['buckets'], [AqaDistributionBucket]);
      if (data.hasOwnProperty('maxCount'))
        obj.maxCount = ApiClient.convertToType(data['maxCount'], 'Number');
      if (data.hasOwnProperty('numberOfBuckets'))
        obj.numberOfBuckets = ApiClient.convertToType(data['numberOfBuckets'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} snapshotId
 */
AqaDistribution.prototype.snapshotId = undefined;

/**
 * @member {String} axis
 */
AqaDistribution.prototype.axis = undefined;

/**
 * @member {Number} position
 */
AqaDistribution.prototype.position = undefined;

/**
 * @member {Array.<module:model/AqaDistributionBucket>} buckets
 */
AqaDistribution.prototype.buckets = undefined;

/**
 * @member {Number} maxCount
 */
AqaDistribution.prototype.maxCount = undefined;

/**
 * @member {Number} numberOfBuckets
 */
AqaDistribution.prototype.numberOfBuckets = undefined;

